import axios from 'axios';
import firebase from '../firebase';
import { localBlogService, isLocalDevelopment } from '../services/localBlogService';

// Base URL for GCF functions - adjust this according to your environment
// For production, this would be something like "https://us-central1-aidronesoftwareprod.cloudfunctions.net"
// For development/UAT, this would be something like "https://us-central1-aidronesoftwareuat.cloudfunctions.net"
const GCF_BASE_URL = process.env.REACT_APP_GCF_BASE_URL



// Helper function to get a fresh Firebase ID token
const getIdToken = async () => {
  const user = firebase.auth().currentUser;
  if (!user) {
    throw new Error('User not authenticated');
  }
  return await user.getIdToken(true);
};

// Function to download software (public/unauthenticated)
// format is optional - only used for Linux (deb or rpm)
export async function publicDownloadSoftware(platform, arch, format = null) {
  try {
    const requestBody = {
      platform: platform,
      arch: arch
    };
    
    // Add format for Linux packages (deb or rpm)
    if (format) {
      requestBody.format = format;
    }
    
    const response = await axios.post(`${GCF_BASE_URL}/public_download_software`, requestBody);
    return response.data;
  } catch (error) {
    console.error('Error downloading software:', error);
    throw new Error(error.response?.data?.error || 'Failed to download software');
  }
}

// Function to log Windows download
export async function logWindowsDownload() {
  try {
    const response = await axios.post(`${GCF_BASE_URL}/log_windows_download`, { 
      platform: 'Windows'
    });
    return response.data;
  } catch (error) {
    console.error('Error logging Windows download:', error);
    throw new Error(error.response?.data?.error || 'Failed to log download');
  }
}


// --- NEW Blog API Functions ---

// Function to get blog list (public/unauthenticated)
export async function getBlogList() {
  try {
    // Check if we should use local development mode
    if (isLocalDevelopment()) {
      return await localBlogService.getBlogList();
    }

    // Production/UAT mode: Use GCF functions
    const response = await axios.get(`${GCF_BASE_URL}/get_blog_list`);
    
    return response.data;

  } catch (error) {
    console.error('Error fetching blog list:', error);
    // Extract error message from response or use a default
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch blog list';
    throw new Error(errorMessage); // Propagate the error for the component to catch
  }
}

// Function to get blog content (public/unauthenticated)
export async function getBlogContent(blogId) {
  try {
    // Check if we should use local development mode
    if (isLocalDevelopment()) {

      return await localBlogService.getBlogContent(blogId);
    }

    // Production/UAT mode: Use GCF functions

    const response = await axios.post(`${GCF_BASE_URL}/get_blog_content`, {
      blog_id: blogId
    });
    return response.data;

  } catch (error) {
    console.error(`Error fetching blog content for ID ${blogId}:`, error);
    // Extract error message from response or use a default
     const errorMessage = error.response?.data?.message || error.message || `Failed to fetch blog content for ID ${blogId}`;
    throw new Error(errorMessage); // Propagate the error for the component to catch
  }
}

// Function to get featured blog (public/unauthenticated)
export async function getFeaturedBlog() {
  try {
    // Check if we should use local development mode
    if (isLocalDevelopment()) {
      console.log('🔧 Development mode: Loading featured blog from local BlogData folder');
      return await localBlogService.getFeaturedBlog();
    }

    // Production/UAT mode: Use GCF functions
    console.log('☁️ Production mode: Loading featured blog from cloud functions');
    const response = await axios.get(`${GCF_BASE_URL}/get_featured_blog`);
    return response.data;

  } catch (error) {
    console.error('Error fetching featured blog:', error);
    // Extract error message from response or use a default
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch featured blog';
    throw new Error(errorMessage); // Propagate the error for the component to catch
  }
}